module.exports = __webpack_public_path__ + "fonts/Firasanssemibolditalic.woff2";